































































































































































































































































































































































































































































































































































































































import {Mixins, Component, Watch} from 'vue-property-decorator';
import Common from '@/components/term/mixins/Common';
import PageTitle from '@/components/common/PageTitle.vue';
import MallTabPlus from '@/components/common/MallTabPlus.vue';
import ContentBottom from '@/components/term/common/ContentBottom.vue';
import editor from '@/components/common/summernote/Index.vue';
@Component({
  components: {
    PageTitle,
    MallTabPlus,
    ContentBottom,
    editor
  }
})
export default class Collection extends Mixins(Common) {
  @Watch('currentMallNo')
  private mallNoChange() {
    this.afterGetTerms();
  }
  private pop() {
    const title = this.toI18n('TERMS_COLLECTION_POPINFO1');
    const popInfo = {
      title,
      subStyle: 'width:540px; max-height:500px; scroll-y:auto',
      footBtn: false,
      noticeBox: '<div class="interchange_guide notice_box no_mark">치환텍스트를 통해 내용을 입력할 수 있습니다.</div><table class="ncp_tbl grid" id="sellerProvisionReplacementTextTable">    <colgroup>        <col width="*">        <col width="*">        <col width="35%">    </colgroup>    <tbody><tr>        <th>치환 텍스트</th>        <th>설명</th>        <th>예시</th>    </tr><tr><td style="color:red;">${partnerName}</td><td>파트너사명</td><td style="text-align: left">1개 파트너사인 경우,<br> :(주)파트너사<br> 2개 이상 파트너사인 경우,<br> :(주)하나파트너, (주)둘파트너</td></tr></tbody></table>'
    };
    this.setPopInfo(popInfo);
    this.setPopIsShow(true);
  }
}
